import src from "IMAGE";
export default { src, width: 503, height: 410, blurWidth: 0, blurHeight: 0};
